module.exports = __webpack_public_path__ + "assets/img/37_1540_big.d93884b9.jpg";